import {priority} from '@priority-software/priority-proto-api/lib';
import {ActivationSource} from '../../../constants/ActivationSource';
export function returnFocus() {
    window['genPage'] && window['genPage'].returnFocus && window['genPage'].returnFocus();
}

export function getCurrentEntity() {
    return (
        window['genPage'] &&
        window['genPage'].getCurrentEntity &&
        window['genPage'].getCurrentEntity()
    );
}

export function restartProc(procName, entityType) {
    return (
        window['genPage'] &&
        window['genPage'].restartProc &&
        window['genPage'].restartProc(procName, entityType)
    );
}

export function getIsAutocomplete() {
    return (
        window['genPage'] &&
        window['genPage'].getIsAutocomplete &&
        window['genPage'].getIsAutocomplete()
    );
}

export function getTryHidingReactMessage() {
    return (
        window['genPage'] &&
        window['genPage'].getTryHidingReactMessage &&
        window['genPage'].getTryHidingReactMessage()
    );
}

export function getDname(): string {
    return window['genPage'] && window['genPage'].getDName && window['genPage'].getDName();
}

export function getConnection() {
    return (
        window['genPage'] && window['genPage'].getConnection && window['genPage'].getConnection()
    );
}

export function setIsNavigationEnabled(isEnbaled) {
    return (
        window['genPage'] &&
        window['genPage'].setIsNavigationEnabled &&
        window['genPage'].setIsNavigationEnabled(isEnbaled)
    );
}

export function getUsername(): string {
    return window['genPage'] && window['genPage'].getUsername && window['genPage'].getUsername();
}

export function getProject(): string {
    return window['genPage'] && window['genPage'].getProject && window['genPage'].getProject();
}
export function sendEmailValidation(email) {
    return (
        window['genPage'] &&
        window['genPage'].sendEmailValidation &&
        window['genPage'].sendEmailValidation(email)
    );
}

export function openNavigationModal(isNext) {
    return (
        window['genPage'] &&
        window['genPage'].OpenNavigationModal &&
        window['genPage'].OpenNavigationModal(isNext)
    );
}

export function buildStorageDataSet(key, value) {
    return (
        window['genPage'] &&
        window['genPage'].buildStorageDataSet &&
        window['genPage'].buildStorageDataSet(key, value)
    );
}

export function setHelpElement(elem) {
    return (
        window['genPage'] &&
        window['genPage'].setHelpElement &&
        window['genPage'].setHelpElement(elem)
    );
}

export function addToHomePage(title, exec) {
    return (
        window['genPage'] &&
        window['genPage'].addToHomePage &&
        window['genPage'].addToHomePage(title, exec)
    );
}
export function setMaxMacroIterations(value) {
    return (
        window['genPage'] &&
        window['genPage'].setMaxMacroIterations &&
        window['genPage'].setMaxMacroIterations(value)
    );
}

export function getMaxMacroIterations() {
    return (
        window['genPage'] &&
        window['genPage'].getMaxMacroIterations &&
        window['genPage'].getMaxMacroIterations()
    );
}

export function getContextData() {
    return (
        window['genPage'] && window['genPage'].getContextData && window['genPage'].getContextData()
    );
}

export function getNextMaxDialogsZIndex(): number {
    return (
        window['genPage'] &&
        window['genPage'].getNextMaxDialogsZIndex &&
        window['genPage'].getNextMaxDialogsZIndex()
    );
}

export function getHomepageEntities() {
    return (
        window['genPage'] &&
        window['genPage'].getHomepageEntities &&
        window['genPage'].getHomepageEntities()
    );
}

export function isPersonalizationSource() {
    return (
        window['genPage'] &&
        window['genPage'].isPersonalizationSource &&
        window['genPage'].isPersonalizationSource()
    );
}

export function getWcfLogin() {
    return window['genPage'] && window['genPage'].getWcfLogin && window['genPage'].getWcfLogin();
}
export function startEntity(
    formName: string,
    columnName: string = null,
    value: string = null,
    subformName: string = null,
    activationSource: number = ActivationSource.None
) {
    return (
        window['genPage'] &&
        window['genPage'].startEntity &&
        window['genPage'].startEntity(formName, columnName, value, subformName, activationSource)
    );
}

export function addNewEntity(session: string, ename: string, title: string) {
    window['genPage'] &&
        window['genPage'].addNewEntity &&
        window['genPage'].addNewEntity(session, ename, title);
}
export function addNewRportsGeneratorEntity(session: string, ename: string, title: string) {
    window['genPage'] &&
        window['genPage'].addNewRportsGeneratorEntity &&
        window['genPage'].addNewRportsGeneratorEntity(session, ename, title);
}

export function endEntity(ent) {
    window['genPage'] && window['genPage'].endEntity && window['genPage'].endEntity(ent);
}

export function endEntityBySession(session) {
    return (
        window['genPage'] &&
        window['genPage'].endEntityBySession &&
        window['genPage'].endEntityBySession(session)
    );
}

export function activateCurEntityBySession(session) {
    window['genPage'] &&
        window['genPage'].activateCurEntityBySession &&
        window['genPage'].activateCurEntityBySession(session);
}

export function checkMail() {
    window['genPage'] && window['genPage'].checkMail && window['genPage'].checkMail();
}

export function generalGetFeedCounter() {
    window['genPage'] &&
        window['genPage'].generalGetFeedCounter &&
        window['genPage'].generalGetFeedCounter();
}

export function runReport(reportID: string, reportType: priority.netitems.nrest.RepType) {
    window['genPage'] &&
        window['genPage'].runReport &&
        window['genPage'].runReport(reportID, reportType);
}

export function runGenReportByTitle(
    reportTitle: string,
    reportType: priority.netitems.nrest.RepType
) {
    window['genPage'] &&
        window['genPage'].runGenReportByTitle &&
        window['genPage'].runGenReportByTitle(reportTitle, reportType);
}

export function initRecentItem(key, item) {
    window['genPage'] &&
        window['genPage'].initRecentItem &&
        window['genPage'].initRecentItem(key, item);
}

export function resetRecentItem() {
    window['genPage'] && window['genPage'].resetRecentItem && window['genPage'].resetRecentItem();
}

export function isActiveScreensOpen() {
    return (
        window['genPage'] &&
        window['genPage'].isActiveScreensOpen &&
        window['genPage'].isActiveScreensOpen()
    );
}

export function openAnalytics() {
    return (
        window['genPage'] && window['genPage'].openAnalytics && window['genPage'].openAnalytics()
    );
}

export function executeOpenCommand(
    ename: string,
    etype: string,
    link: string,
    linkid: string,
    table: string,
    session: string
) {
    window['genPage'] &&
        window['genPage'].executeOpenCommand &&
        window['genPage'].executeOpenCommand(ename, etype, link, linkid, table, session);
}

export function getCompanyCountryByDname() {
    return (
        window['genPage'] &&
        window['genPage'].getCompanyCountryByDname &&
        window['genPage'].getCompanyCountryByDname()
    );
}

export function getHasAnalyticsPermissions() {
    return (
        window['genPage'] &&
        window['genPage'].getHasAnalyticsPermissions &&
        window['genPage'].getHasAnalyticsPermissions()
    );
}

export function getAlertFlag() {
    return window['genPage'] && window['genPage'].getAlertFlag && window['genPage'].getAlertFlag();
}

export function handleFormFatalError() {
    return window['genPage']?.handleFormFatalError?.();
}

export function openPackagesPanel() {
    window['genPage']?.openPackagesPanel?.();
}

export function isCurrentEntBPM(): boolean {
    return window['genPage']?.isCurrentEntBPM?.();
}

export function isCurrentEntADP(): boolean {
    return window['genPage']?.isCurrentEntADP?.();
}

export function getCurProcDname(): string {
    return window['genPage']?.getCurProcDname?.();
}

export function getCompanyBrushColorRGB(): string {
    return window['genPage']?.getCompanyBrushColorRGB?.();
}

export function startProcWithActivationSource(ename: string, activationSource: number): boolean {
    return window['genPage']?.startProcWithActivationSource?.(ename, activationSource);
}

export function getAppName(): string {
    return window['genPage']?.getAppName?.();
}

export function getEntDTitle(): string {
    return window['genPage']?.getEntDTitle?.();
}

export function changeCompanyStatic(company: string, profile: number): string {
    return window['genPage']?.changeCompanyStatic?.(company, profile);
}

export function getGoogleMapsApiKey(): string {
    return window['genPage']?.getGoogleMapsApiKey?.();
}
export function closeCurrentAndMinimizeAll(): string {
    return window['genPage']?.closeCurrentAndMinimizeAll?.();
}
